/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    outletItemPrices: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerOutletItemPrices = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_OUTLET_ITEM_PRICES':
            var { data } = action;
            newState.outletItemPrices = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerOutletItemPrices;